module.exports = __webpack_public_path__ + "img/icon_insta.svg?d62e476f87681cfc5315e34ddae27683";